import { PaginationType } from "../../Types/APITypes";
import { 
  GuestbookEntry, 
  GuestbookResponse, 
  GuestbookStatisticsResponse,
  GuestbookEntryResponse,
  GuestbookDeleteResponse
} from '../../Types/guestbook';
import API from "./API";

class GuestbookAPI extends API {
  // Récupérer tous les témoignages avec pagination et recherche
  static get_all_entries = (pagination?: PaginationType) => {
    return this.getRequest(
      `manage/guestbook/entries?page=${pagination?.current_page || 1}&per_page=${
        pagination?.per_page || 10
      }${pagination?.search_word ? `&query=${pagination.search_word}` : ""}`,
      true
    );
  };

  // Récupérer les témoignages en attente de modération
  static get_pending_entries = (pagination?: PaginationType) => {
    return this.getRequest(
      `manage/guestbook/entries/pending?page=${pagination?.current_page || 1}&per_page=${
        pagination?.per_page || 10
      }`,
      true
    );
  };

  // Approuver un témoignage
  static approve_entry = (id: number) => {
    return this.patchRequest(`manage/guestbook/entries/${id}/approve`, {}, true);
  };

  // Rejeter un témoignage
  static reject_entry = (id: number) => {
    return this.patchRequest(`manage/guestbook/entries/${id}/reject`, {}, true);
  };

  // Supprimer définitivement un témoignage
  static delete_entry = (id: number) => {
    return this.deleteRequest(`manage/guestbook/entries/${id}/delete`, {}, true);
  };

  // Récupérer les statistiques du livre d'or
  static get_statistics = () => {
    return this.getRequest(`manage/guestbook/entries/statistics`, true);
  };
}

export default GuestbookAPI; 